<template><div><h1>为什么作者直接删除了我在 issue 下的评论</h1>
<div class="warning">
<p>被删除评论一般是因为：你在 issue 下写了一条和当前 issue 没有关系的评论，或者提了和 issue 无关的问题。</p>
</div>
<p>即使是关于同一个组件，和当前 issue 讨论主题无关的评论也会造成管理麻烦，影响讨论。</p>
<p>作为维护者我们想让每条 issue 讨论主题集中，以便管理追踪。</p>
<p>作为 issue 创建者同样如此，试想你愿意别人在你的网站发无关内容或者垃圾吗？</p>
<p>尊重他人，理解作为维护者管理每条 issue 所花费的时间精力再提问可以得到更好和更快的帮助。</p>
</div></template><script>
export default {
  head: {"title":"为什么作者直接删除了我在 issue 下的评论 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// why-delete-my-issue-comment-63.vue?49000980